import VueTypes from 'vue-types';
import { BOOKING_TYPES, BOOKING_STATUSES } from '@/mikan/_shared/constants/booking';
import { RESERVATION_CHECK_LIST_STATUS } from '@/mikan/_shared/constants/reservations';

export const VTBookingId = VueTypes.string;
const BaseBookingProps = {
  id: VTBookingId.isRequired,
  type: VueTypes.oneOf(Object.values(BOOKING_TYPES)).isRequired,
  date: VueTypes.string.isRequired,
  startTime: VueTypes.string.isRequired,
  endTime: VueTypes.string.isRequired,
  firstName: VueTypes.string.isRequired,
  lastName: VueTypes.string.isRequired,
  numberOfCustomers: VueTypes.integer.isRequired,
};
export const InstantBookingProps = {
  ...BaseBookingProps,
  spotName: VueTypes.string.isRequired, // reservation_details の spot_json カラムにあるスナップショットから取得するためrelation無し
  status: VueTypes.oneOf([BOOKING_STATUSES.RESERVED, BOOKING_STATUSES.CANCELLED]),
  // 以下の項目は「予約実績の確認」ページで使われるオプション
  confirmDate: VueTypes.string,
  confirmType: VueTypes.oneOf(Object.values(RESERVATION_CHECK_LIST_STATUS)),
  amount: VueTypes.integer,
  isPayPerUseReservation: VueTypes.bool.def(false),
};
export const VTInstantBooking = VueTypes.shape(InstantBookingProps);

export const RequestedBookingProps = {
  ...BaseBookingProps,
  spotName: VueTypes.string.def(''), // reservation_details の spot_json カラムから取得
  status: VueTypes.oneOf([BOOKING_STATUSES.NOT_RESPONDED, BOOKING_STATUSES.RESERVED, BOOKING_STATUSES.CANCELLED]),
};
export const VTRequestedBooking = VueTypes.shape(RequestedBookingProps);
